import Swal from 'sweetalert2'
import {
    IS_LOADING_LIST_OF_COLORS_REACTIONS,CREATE_COLOR_REACTION,LIST_OF_COLORS_REACTIONS,EDIT_COLOR_REACTION,DELETE_COLOR_REACTION,IS_LOADING_COLOR_REACTION,
    COLOR_REACTION_INFO

} from './types'
import {
    urlServer
} from '../../config/GlobalConstant'
import inMemoryJWT from '../../auth/inMemoryJwt';

//color of reactions management

export const createColorsReaction = (color, history) => async dispatch => {

    await fetch(`${urlServer}api/colors/create`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify(color)
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (respJson.success === true) {
                if (respJson.success === true) {
                    dispatch({
                        type: IS_LOADING_LIST_OF_COLORS_REACTIONS
                    });
                    dispatch({ 
                        type: CREATE_COLOR_REACTION,
                        payload: respJson.data
                    });
                }
    
            }

        })
        .catch(error => {
            console.log()
        })
}
export const seeListColorsReactions = (history) => async dispatch => {
    
    await fetch(`${urlServer}reactions/get`, {
        method: 'GET', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if(respJson.success===true)
            {dispatch({
                type: IS_LOADING_LIST_OF_COLORS_REACTIONS
            });
            dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                type: LIST_OF_COLORS_REACTIONS,
                payload: respJson.data
            });}
        })
        .catch(error => {
            console.log()
        })
}
export const seeColorReaction = (id, history) => async dispatch => {
    
    await fetch(`${urlServer}api/colors/get-color-by-any-field`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify({colorId:id})
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if(respJson.success===true)
            {dispatch({
                type: IS_LOADING_COLOR_REACTION
            });
            dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                type: COLOR_REACTION_INFO,
                payload: respJson.data
            });}
        })
        .catch(error => {
            console.log()
        })
}

export const editColorReaction = (colorEdited, index,history) => async dispatch => {
    console.log()
    await fetch(`${urlServer}api/colors/update`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify(colorEdited)
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (respJson.error === null) {
                dispatch({
                    type: IS_LOADING_LIST_OF_COLORS_REACTIONS
                });
                dispatch({ 
                    type: EDIT_COLOR_REACTION,
                    payload:{data:respJson.data, index:index}
                });
            }
        })
        .catch(error => {
            console.log()
        })
}
export const deleteColorReaction = (id, index) => async dispatch => {
   
    await fetch(`${urlServer}api/colors/delete`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify({ colorId: id })
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if(respJson.success===true)
            {dispatch({
                type: IS_LOADING_LIST_OF_COLORS_REACTIONS
            });
            dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                type: DELETE_COLOR_REACTION,
                payload: index
            });}
        })
        .catch(error => {
            console.log()
        })
}